import { SET_MQTT_CONNECTION } from '../constants/MQTTConstants';

export function setMQTTConnection(status) {
  return {
    type: SET_MQTT_CONNECTION,
    payload: status,
  };
}
